import { makeStyles } from "tss-react/mui"
import { faImage } from "@fortawesome/pro-regular-svg-icons"
import { IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TimelineResourceGroupLabelContent } from "../calendar/fullCalendarTypes"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    icon: {
        color: theme.palette.tailwind.slate[800],
    },
}))

type ResourceCalendarGroupContentProps = Readonly<{
    resourceContent: TimelineResourceGroupLabelContent
    groupImagesMap: Map<string, string>
    onImageClick: (imageUrl: string) => void
}>

export function ResourceCalendarGroupContent({
    resourceContent,
    groupImagesMap,
    onImageClick,
}: ResourceCalendarGroupContentProps) {
    const { classes } = useStyles()
    const { groupValue } = resourceContent
    const groupImageUrl = groupImagesMap.get(groupValue)

    const handleImageClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        if (groupImageUrl) {
            onImageClick(groupImageUrl)
        }
    }

    return (
        <Stack flexDirection="row" alignItems="center" justifyContent="space-between" flexWrap="nowrap" gap="1rem">
            <Typography variant="body1" fontWeight="bold">
                {groupValue}
            </Typography>
            {groupImageUrl && (
                <LocalizedStrict id="create-order-tooltip-resource-image-button" attrs={{ title: true }}>
                    <Tooltip title="View floor plan image">
                        <IconButton onClick={handleImageClick} size="small">
                            <FontAwesomeIcon icon={faImage} className={classes.icon} />
                        </IconButton>
                    </Tooltip>
                </LocalizedStrict>
            )}
        </Stack>
    )
}
